(() => {
  const selector = '[data-wor-cookie], #cookie-bar';
  const observed = new WeakSet();
  let scheduled = false;
  const resizeObserver = new ResizeObserver(schedule);
  function update() {
    scheduled = false;
    let clearance = 0;
    document.querySelectorAll(selector).forEach(banner => {
      if (!observed.has(banner)) { resizeObserver.observe(banner); observed.add(banner); }
      const style = getComputedStyle(banner); const rect = banner.getBoundingClientRect();
      if (!banner.hidden && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.height > 0 && rect.width > 0 && rect.bottom >= innerHeight - 16 && rect.top < innerHeight) clearance = Math.max(clearance, innerHeight - Math.max(0, rect.top));
    });
    const value = `${Math.ceil(clearance)}px`;
    if (document.documentElement.style.getPropertyValue('--wor-cookie-clearance') !== value) document.documentElement.style.setProperty('--wor-cookie-clearance', value);
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.matches?.(selector) || record.target.closest?.(selector))) schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden','style','class'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule); update();
})();
